// src/components/blog/BlogRelatedPosts.jsx

import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { formatDate, getBlogImageUrl } from '../../utils/blogUtils';

const BlogRelatedPosts = memo(({ posts, isDark, onImageError }) => {
  if (!posts || posts.length === 0) return null;

  return (
    <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800">
      <h2 className={`text-2xl font-bold mb-6 ${isDark ? 'text-white' : 'text-gray-900'}`}>
        Related Articles
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {posts.map((post) => (
          <Link 
            key={post.id} 
            to={`/blog/${post.slug}`}
            className="group"
          >
            <div className={`rounded-xl overflow-hidden transition-all duration-300 hover:transform hover:scale-[1.02] ${
              isDark 
                ? 'bg-white/5 border border-white/10' 
                : 'bg-white border border-gray-200'
            }`}>
              <div className="h-40 overflow-hidden bg-gradient-to-br from-blue-500/20 to-blue-600/20">
                <img 
                  src={getBlogImageUrl(post.featured_image, post.title)}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={() => onImageError?.(post.featured_image)}
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <h3 className={`font-semibold mb-2 line-clamp-2 group-hover:text-blue-400 transition-colors ${isDark ? 'text-white' : 'text-gray-900'}`}>
                  {post.title}
                </h3>
                <p className={`text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
                  {formatDate(post.published_at)}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
});

BlogRelatedPosts.displayName = 'BlogRelatedPosts';

export default BlogRelatedPosts;